import React from 'react';
import { NavLink } from 'react-router-dom';
import logo from '../../images/logo.png';
import './Header.css'

const Header = () => {
    return (
        <div className="header">
            <img src={logo} alt="" className="logo" />
            <nav>
                <NavLink to="/shop">Shops</NavLink>
                <NavLink to="/review">Order review</NavLink>
                <NavLink to="/inventory">Manage Inventory</NavLink>
            </nav>

        </div>
    );
};

export default Header;